import styled from '@emotion/styled';
import { COLOR_GREEN } from 'client/components/MarketingPagesShared/styles';
import { SCREEN_BREAKPOINTS } from '../../constants';

const Section = styled.section`
  max-width: 1400px;
  margin: 260px auto 100px;
  text-align: center;
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    margin: 120px auto;
  }
`;

const Container = styled.div`
  padding: 0 5%;
  color: ${COLOR_GREEN};
  h2 {
    width: 80%;
    margin: 0 auto 100px;
    font-weight: 900;
    font-size: 6rem;
    line-height: 7rem;
  }
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    h2 {
      width: 100%;
      margin: 0 auto 50px;
      font-size: 2.8rem;
      line-height: 3.8rem;
    }
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-gap: 80px;
  grid-template-columns: repeat(4, minmax(15%, 250px));
  width: 100%;
  max-width: 1240px;
  margin: 0 auto 70px;
  line-height: 2.6rem;
  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    grid-gap: 100px;
    grid-template-columns: repeat(2, 1fr);
    padding: 0 32px;
  }
  @media (max-width: 600px) {
    grid-row-gap: 50px;
    grid-column-gap: 24px;
    grid-template-columns: 1fr;
    padding: 0 24px;
  }
`;

const SellingPoint = styled.div`
  svg {
    width: 100%;
    max-width: 150px;
  }
  h3 {
    margin: 18px 0 20px;
    font-size: 2rem;
  }
  p {
    font-size: 1.6rem;
  }
  @media (max-width: 600px) {
    svg {
      max-width: 150px;
    }
  }
`;

export { Container, GridContainer, Section, SellingPoint };
